import { getAuthToken } from "./auth";

const contentTypeHeader = { "Content-Type": "application/json; charset=utf-8" };

const getAuthHeader = async (): Promise<any> => {
  let jwt: string | undefined;

  if (import.meta.env.MODE == "development") jwt = import.meta.env.VITE_JWT_TEST_TOKEN;
  else jwt = await getAuthToken();

  if (!jwt || jwt === "null") throw new Error('JWT token not found');

  return { Authorization: "Bearer " + jwt };
};

export const getHeadersJWT = async () => ({
  ...contentTypeHeader,
  ...(await getAuthHeader()),
});

export const getHeaders = () => ({
  ...contentTypeHeader
});